import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { SlickCarouselComponent } from "ngx-slick-carousel";

@Component({
  selector: 'app-galeria',
  templateUrl: './galeria.component.html',
  styleUrls: ['./galeria.component.scss']
})
export class GaleriaComponent implements OnInit {

  @Input() galeria = [];
  @ViewChild("slickModal") slickModal: SlickCarouselComponent;
  
  slideConfig = {
    arrows: false,
    // appendDots: $(.dots'),
    dots: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerPadding: '80px',
    responsive: [{
      breakpoint: 991,
      settings: {
        slidesToShow: 1
      }
    }]
  };

  constructor() { }

  ngOnInit(): void {
    // setTimeout(() => {
    //   this.slickModal.initSlick();
    // }, 1000);

    console.log(this.galeria);
  }



}
